import {
  CONSTRUCTION_BUDGET_CATEGORY_OPTIONS,
  CONSTRUCTION_TYPE_OPTIONS,
} from 'store/construction/types';

// AutocompleteCDS is a controlled OPTION-object picker, but the draft stores only the enum id — resolve
// the id back to its option object (or null) so the field reflects the current selection.
export const getCategoryOption = category =>
  CONSTRUCTION_BUDGET_CATEGORY_OPTIONS.find(option => option.id === category) ?? null;

export const getConstructionTypeOption = constructionType =>
  CONSTRUCTION_TYPE_OPTIONS.find(option => option.id === constructionType) ?? null;
